import React, { Component } from 'react';
import { get_dogilocker_adhaar, getDigiLockerVerfication } from '../../actions/accountAction';
import { get_entitylocker, getEntityLockerVerification } from '../../actions/accountAction';
import { connect } from 'react-redux';
import store from '../../store'
import Loader from 'react-loader-spinner';

class VerifyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            error: null
        };

        // Check user type and call appropriate verification
        const loginType = localStorage.getItem("login_type");
        if (loginType === "Indian Employer") {
            store.dispatch(getEntityLockerVerification());
        } else {
            // Default to DigiLocker for Jobseekers
            store.dispatch(getDigiLockerVerfication());
        }
    }

    componentDidMount() {
        // Ensure we stay on verify-profile page after callback from entity locker
        // Don't redirect anywhere automatically
        const loginType = localStorage.getItem("login_type");

        // CRITICAL: Ensure login state is ALWAYS preserved (entity locker callback might clear it)
        // This prevents auth HOC from redirecting to home page
        if (localStorage.getItem('token')) {
            localStorage.setItem('Islogin', 'true');
            // Also ensure login_type is preserved
            if (!localStorage.getItem('login_type') && loginType) {
                localStorage.setItem('login_type', loginType);
            }
        }

        // For employers: Prevent any navigation away from verify-profile
        if (loginType === "Indian Employer") {
            // If we're not on verify-profile, redirect back immediately
            const currentPath = window.location.pathname;
            if (currentPath !== '/verify-profile' && !currentPath.includes('/verify-profile') &&
                !currentPath.includes('entity.digilocker.gov.in')) {
                if (this.props.router) {
                    this.props.router.replace('/verify-profile');
                    return;
                }
            }

            // Re-check verification status when component mounts (e.g., after callback)
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.toString()) {
                // We have callback parameters, call verification API
                store.dispatch(getEntityLockerVerification());
            } else {
                // No callback params, just check current status
                store.dispatch(getEntityLockerVerification());
            }
        }
    }

    componentDidUpdate(prevProps) {
        const loginType = localStorage.getItem("login_type");

        if (loginType === "Indian Employer") {
            // For employers: STOP all navigation - keep them on verify-profile page
            // Only allow initial redirect to external entity locker URL

            const prevError = prevProps.actionReducer?.entityVerification?.error;
            const currentError = this.props.actionReducer?.entityVerification?.error;
            const currentEntityVerification = this.props.actionReducer?.entityVerification;
            const prevEntityVerification = prevProps.actionReducer?.entityVerification;

            // Redirect to Entity Locker URL
            const prevUrl = prevProps.actionReducer?.entityUrl;
            const currentUrl = this.props.actionReducer?.entityUrl;
            if (prevUrl !== currentUrl && currentUrl) {
                window.location.href = currentUrl;
                return;
            }

            // Check if user_loggedout error occurred
            if (currentError === "user_loggedout" && prevError !== "user_loggedout") {
                // Hide section → set local state
                this.setState({ hideSection: true });

                // Call EntityLocker API again
                this.props.dispatch(get_entitylocker());
            }

            // ONLY allow redirect to external entity locker URL (for initial verification)
            // Do NOT redirect for any other URLs - stay on verify-profile
            if (currentEntityVerification?.entitylocker_url &&
                currentEntityVerification?.entitylocker_url !== prevEntityVerification?.entitylocker_url &&
                !currentEntityVerification?.is_verified) {
                // Only redirect if it's an external entity locker URL
                if (currentEntityVerification.entitylocker_url.includes('entity.digilocker.gov.in') ||
                    currentEntityVerification.entitylocker_url.includes('digilocker')) {
                    // Redirect to EntityLocker URL (external)
                    window.location.href = currentEntityVerification.entitylocker_url;
                    return;
                }
                // If not external entity locker URL, stay on verify-profile
            }

            // DO NOT check entityUrl - prevent any redirects from Sidebar or other sources
            // Stay on verify-profile page no matter what

            // After verification is complete, stay on verify-profile page
            if (currentEntityVerification?.is_verified &&
                (!prevEntityVerification?.is_verified || prevEntityVerification?.is_verified !== currentEntityVerification?.is_verified)) {
                // Verification completed - stay on this page, show success message
                this.setState({ hideSection: false });
            }
        } else {
            // DigiLocker logic for jobseekers
            const prevError = prevProps.actionReducer?.digiVerification?.error;
            const currentError = this.props.actionReducer?.digiVerification?.error;
            const currentDigiVerification = this.props.actionReducer?.digiVerification;
            const prevDigiVerification = prevProps.actionReducer?.digiVerification;

            // Check if user_loggedout error occurred
            if (currentError === "user_loggedout" && prevError !== "user_loggedout") {
                // Hide section → set local state
                this.setState({ hideSection: true });

                // Call Aadhaar API again
                this.props.dispatch(get_dogilocker_adhaar());
            }

            // Check if digilocker_url is available in digiVerification response and redirect
            if (currentDigiVerification?.digilocker_url &&
                currentDigiVerification?.digilocker_url !== prevDigiVerification?.digilocker_url &&
                !currentDigiVerification?.is_verified) {
                // Redirect to DigiLocker URL
                window.location.href = currentDigiVerification.digilocker_url;
                return;
            }

            // Also check digiUrl from get_dogilocker_adhaar response
            const currentDigiUrl = this.props.actionReducer?.digiUrl;
            const prevDigiUrl = prevProps.actionReducer?.digiUrl;

            if (currentDigiUrl && currentDigiUrl !== prevDigiUrl && typeof currentDigiUrl === 'string') {
                // Redirect to DigiLocker URL
                window.location.href = currentDigiUrl;
                return;
            }
        }
    }

    handleReverify = () => {
        const loginType = localStorage.getItem("login_type");

        if (loginType === "Indian Employer") {
            // Redirect to EntityLocker logout page
            // window.location.href = "https://entity.digilocker.gov.in/signin/logout/Y";
            store.dispatch(get_entitylocker())
        } else {
            // Redirect to DigiLocker logout page
            window.location.href = "https://digilocker.meripehchaan.gov.in/signin/logout/Y";
        }
    };

    render() {
        const loginType = localStorage.getItem("login_type");
        const { hideSection } = this.state;

        // For employers: Ensure login state is set to prevent auth HOC redirect
        if (loginType === "Indian Employer") {
            // Ensure Islogin is set to prevent auth HOC from redirecting to home
            if (localStorage.getItem('token') && localStorage.getItem('Islogin') !== 'true') {
                localStorage.setItem('Islogin', 'true');
            }

            // Only check path once, don't redirect in render (causes loops)
            // The auth HOC will handle staying on verify-profile
        }

        let verification, loading, error, message, isVerified;

        if (loginType === "Indian Employer") {
            verification = this.props.actionReducer?.entityVerification;
            loading = this.props.actionReducer?.loading;
            error = this.props.actionReducer?.error;
            message = verification?.message;
            isVerified = verification?.is_verified;
        } else {
            verification = this.props.actionReducer?.digiVerification;
            loading = this.props.actionReducer?.loading;
            error = this.props.actionReducer?.error;
            message = verification?.message;
            isVerified = verification?.is_verified;
        }

        // Don't block rendering on loading - show the page with processing message
        // Only show error if it's a real error (not just loading state)
        if (error && error !== "user_loggedout" && !verification) {
            return (
                <div className="container mt-5">
                    <div className="alert alert-danger">Error: {error}</div>
                </div>
            );
        }

        return (
            <div>
                {!hideSection && (
                    <section className="top-inner animatedParent main-content-height mb-5">
                        <div className="container">
                            {loading ? (
                                <Loader style={{ position: 'fixed', top: '49%', left: '48%' }}
                                    type="Rings"
                                    color="#F1911C"
                                    height={100}
                                    width={100}
                                />
                            ) :
                                (
                                    <div className="" style={{ marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                                        <div className={"col-md-6 col-lg-6 col-sm-6 mt-5"} style={{ fontSize: "24px" }}>
                                            {message}
                                        </div>
                                        {isVerified ?
                                            <div className={"col-md-12 col-lg-12 col-sm-12 mb-5"} style={{ marginTop: "50px" }}>
                                                <button
                                                    aria-label="Go back"
                                                    onClick={() => this.props.router.push('/myaccount')}
                                                    className="btn btn-primary btn-primary2 mr-2 mx-auto d-block">Go To Dashboard
                                                </button>
                                            </div>
                                            :
                                            <div className={"col-md-12 col-lg-12 col-sm-12 mb-5"} style={{ marginTop: "50px" }}>
                                                <button
                                                    aria-label="Reverify"
                                                    onClick={() => this.handleReverify()}
                                                    className="btn btn-primary btn-primary2 mr-2 mx-auto d-block">Reverify
                                                </button>
                                            </div>
                                        }

                                    </div>
                                )}

                        </div>
                    </section>
                )}
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return store;
};

export default connect(mapStateToProps)(VerifyProfile);

